import { useState } from 'react';
import {
    Box,
    Container,
    Typography,
    Button,
    useTheme,
    useMediaQuery
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ContactSupport as ContactIcon } from '@mui/icons-material';
import logo from '../assets/img/logo.png';
import HomePopup from '../components/popups/HomePopup';
import ContactPopup from '../components/popups/ContactPopup';

const Home = () => {
    const [dialogOpen, setDialogOpen] = useState(() => {
        // Check if we've shown the dialog this session
        return !sessionStorage.getItem('welcomeDialogShown');
    });
    const [contactDialogOpen, setContactDialogOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();

    const handleCloseDialog = () => {
        // Mark the dialog as shown for this session
        sessionStorage.setItem('welcomeDialogShown', 'true');
        setDialogOpen(false);
    };

    const handleSignUp = () => {
        navigate('/register');
    };

    return (
        <Box 
            sx={{ 
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'background.default'
            }}
        >
            <HomePopup open={dialogOpen} onClose={handleCloseDialog} />
            <ContactPopup open={contactDialogOpen} onClose={() => setContactDialogOpen(false)} />
            
            <Container maxWidth="lg">
                <Box 
                    sx={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        pt: isMobile ? 4 : 8,
                        pb: 6 
                    }}
                >
                    <img 
                        src={logo} 
                        alt="Total Turf Experience"
                        style={{ 
                            width: isMobile ? '200px' : '300px',
                            marginBottom: '2rem'
                        }}
                    />
                    <Typography
                        variant={isMobile ? 'h4' : 'h3'}
                        component="h1"
                        align="center"
                        color="primary"
                        gutterBottom
                        sx={{ fontWeight: 'bold', mb: 4 }}
                    >
                        Administrative Portal
                    </Typography>

                    <Typography
                        variant="h6"
                        align="center"
                        color="text.secondary"
                        paragraph
                        sx={{ mb: 4, maxWidth: 600 }}
                    >
                        Access your account and check in to the facility all in one place.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => navigate('/login')}
                            sx={{ 
                                minWidth: 200,
                                py: 1.5
                            }}
                        >
                            Log In
                        </Button>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={handleSignUp}
                            color="secondary"
                            sx={{ 
                                minWidth: 200,
                                py: 1.5
                            }}
                        >
                            Sign Up
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/faq')}
                            sx={{ 
                                minWidth: 200,
                                py: 1.5
                            }}
                        >
                            View FAQ
                        </Button>
                    </Box>
                    <Typography
                        variant="body1"
                        color="primary"
                        sx={{ 
                            mt: 4,
                            cursor: 'pointer',
                            '&:hover': {
                                textDecoration: 'underline'
                            }
                        }}
                        onClick={() => setContactDialogOpen(true)}
                    >
                        Having issues? Contact us
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Home; 